import { ForbiddenValuesByOperation } from './types';

export const TIMESTREAM_FORBIDDEN_VALUES: ForbiddenValuesByOperation = {
  CreateDatabaseRequest: {
    '^DatabaseName$': 'test',
  },
};
